import axios, { AxiosError, AxiosInstance } from 'axios';
import { signOut } from 'firebase/auth';

import { auth } from '../config/firebase';

const baseURL = import.meta.env.REACT_APP_URL ? import.meta.env.REACT_APP_URL : 'https://europe-west1-hotelspot-dev.cloudfunctions.net';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

// Dołącza Firebase ID token (jeśli brak ręcznie ustawionego) — endpointy v3
// autoryzują nim zalogowanego użytkownika panelu.
axiosInstance.interceptors.request.use(async (config) => {
  if (!config.headers.Authorization) {
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Odpowiedzi błędów z v3 mają kształt `{success, message, data}`. Bez tego
// interceptora komponenty pokazywały `Request failed with status code 403`
// zamiast treści z backendu.
//
// 401 = brak/nieważny token → wylogowanie i powrót na ekran logowania.
// 403 = konto bez uprawnień administratora (`verifyAdminAccess`) → ekran „brak
// dostępu"; sesja zostaje, bo to nie jest problem z tokenem.
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError<{ message?: string }>) => {
    const status = error.response?.status;
    const backendMessage = error.response?.data?.message;

    if (backendMessage) {
      // eslint-disable-next-line no-param-reassign
      error.message = backendMessage;
    }

    if (status === 401) {
      await signOut(auth).catch(() => undefined);
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }

    if (status === 403 && window.location.pathname !== '/unauthorized') {
      window.location.assign('/unauthorized');
    }

    return Promise.reject(error);
  },
);
